module.exports = __webpack_public_path__ + "img/first-1.1536eff4.webp";